/**
 * Avance de obra que ve el inversor: dos lecturas independientes.
 *
 *   general — el complejo entero. Un solo documento de proyecto
 *             (`GET /construction-state`), el mismo para todos los
 *             inversores. Lo edita «Estado general de obra».
 *   villa   — la villa concreta. Los campos manuales de la propia villa
 *             (`overall_progress_pct_manual`, `current_milestone_key_manual`,
 *             `last_progress_update_manual`), que edita `EstadoDeObraPanel`
 *             vía `PATCH /villas/{id}/construction-state`.
 *
 * Ninguna de las dos se rellena con la otra, ni con los hitos por villa, ni
 * con las fotos publicadas: un porcentaje que nadie ha registrado es
 * `null` («Pendiente de actualización»), nunca un 0 % calculado. Un 0
 * guardado expresamente sí es un dato y se muestra.
 */

/** Porcentaje registrado (0-100, entero) o `null` si no hay ninguno. */
export function registeredPct(value) {
  if (typeof value !== "number" || !Number.isFinite(value)) return null;
  return Math.max(0, Math.min(100, Math.round(value)));
}

function text(value) {
  return typeof value === "string" && value.trim() ? value.trim() : null;
}

/** Avance general del complejo, desde el estado de obra del proyecto. */
export function generalProgress(constructionState) {
  const s = constructionState || {};
  return {
    pct: registeredPct(s.overall_progress_pct_manual),
    phaseKey: text(s.current_milestone_key_manual),
    updatedAt: text(s.last_progress_update_manual),
    note: text(s.progress_note_manual),
  };
}

/** Avance individual de una villa, desde sus propios campos manuales. */
export function villaProgress(villa) {
  const v = villa || {};
  return {
    pct: registeredPct(v.overall_progress_pct_manual),
    phaseKey: text(v.current_milestone_key_manual),
    updatedAt: text(v.last_progress_update_manual),
    note: text(v.progress_note_manual),
  };
}
